var map = {
	"./ammo.png": "34e5",
	"./back.png": "a70c",
	"./backpack.png": "2697",
	"./bag.png": "37ac",
	"./body.png": "e4ba",
	"./chest.png": "c615",
	"./feet.png": "61aa",
	"./finger.png": "19ff",
	"./hands.png": "96c9",
	"./head.png": "7b64",
	"./item_frame.png": "8929",
	"./item_frame_hover.png": "7269",
	"./item_questionmark.png": "411b",
	"./legs.png": "3ac8",
	"./mainhand.png": "0a19",
	"./neck.png": "75a2",
	"./ranged.png": "0227",
	"./relic.png": "b74d",
	"./shield.png": "506c",
	"./shoulders.png": "71e6",
	"./tabard.png": "e2f2",
	"./trinket.png": "f826",
	"./waist.png": "f117",
	"./wrist.png": "d462"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e80d";